import(/* webpackMode: "eager" */ "/home/runner/work/iticket-shopsite/iticket-shopsite/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/iticket-shopsite/iticket-shopsite/public/images/room_with_hella_lights.jpg");
